import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const HEADQUARTER_ASSETS_ENDPOINT = "/headquarter-asset";

export class HeadquarterAssetService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE ACTIVOS DE UNA SEDE
     * @EN GETS THE LIST OF HEADQUARTER ASSETS
     */
    // -------------------------------------------------------------------------------------------------------------
    listAssets = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTER_ASSETS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN ACTIVO POR SU ID
     * @EN GETS AN ASSET BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getAssetById = async (assetId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTER_ASSETS_ENDPOINT + "/get",
            data: { id: assetId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN ACTIVO
     * @EN CREATES AN ASSET
     */
    // -------------------------------------------------------------------------------------------------------------
    createAsset = async (asset: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTER_ASSETS_ENDPOINT + "/create",
            data: asset,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN ACTIVO
     * @EN EDITS AN ASSET
     */
    // -------------------------------------------------------------------------------------------------------------
    editAsset = async (asset: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTER_ASSETS_ENDPOINT + "/edit",
            data: asset,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN ACTIVO
     * @EN DELETES AN ASSET
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteAsset = async (assetId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTER_ASSETS_ENDPOINT + "/delete",
            data: { id: assetId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}
